import React from "react";
import { RouteComponentProps } from "react-router";
import { WSQueries } from "../../../query/WSQuery";
import { PayableForm } from "../../components/PayableForm/PayableForm";
import { CustomFieldResourceType } from "@wingspanhq/wingspan-api-sdk";
import { queriesCustomFields } from "@query";

export const CreatePayable: React.FC<
  RouteComponentProps<any, any, { email?: string; backPath?: string }>
> = ({ location }) => {
  const email = location.state?.email;

  const queryCustomFields = queriesCustomFields.listCustomFields.useQueryAll({
    filter: { resourceType: { eq: CustomFieldResourceType.LINE_ITEM } }
  });
  const customFields = queryCustomFields.flatData;
  const backPath = location.state?.backPath;

  return (
    <WSQueries queries={{ queryCustomFields }}>
      {() => (
        <PayableForm
          backPath={backPath}
          customFields={customFields}
          email={email}
        />
      )}
    </WSQueries>
  );
};
